import { isMigratedPathname, stripLocalePrefix } from '~/i18n/i18n-config';
import { useRouter } from '~/i18n/navigation';

export const usePushToMigratedRoute = () => {
  const router = useRouter();

  return (href: string) => {
    if (isMigratedPathname(stripLocalePrefix(globalThis.location.pathname))) {
      router.push(href);
      return;
    }

    globalThis.location.assign(href);
  };
};
